var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.terms_obj.length > 0
    ? _c(
        "div",
        { staticClass: "row pt-4" },
        [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "checkbox-el" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.checkAll,
                    expression: "checkAll",
                  },
                ],
                staticClass: "checkbox-el__input",
                attrs: { name: "checkAll", type: "checkbox", id: "checkAll" },
                domProps: {
                  checked: Array.isArray(_vm.checkAll)
                    ? _vm._i(_vm.checkAll, null) > -1
                    : _vm.checkAll,
                },
                on: {
                  change: [
                    function ($event) {
                      var $$a = _vm.checkAll,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.checkAll = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.checkAll = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.checkAll = $$c
                      }
                    },
                    _vm.checkAllClick,
                  ],
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass:
                    "checkbox-el__label checkbox-el__label--padding-small d-flex justify-content-between align-items-center",
                  attrs: { for: "checkAll" },
                },
                [
                  _c("span", { staticClass: "d-flex align-items-center" }, [
                    _c("span", { staticClass: "checkmark mr-4" }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "checkbox-el__label__text checkbox-el__label__text--small font__family--gotham font__weight--medium font__color--gray",
                      },
                      [_vm._v(_vm._s(_vm.$t("select_all", "form_acceptance")))]
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm._l(_vm.terms_obj, function (term, index) {
            return _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                {
                  staticClass: "checkbox-el",
                  class: {
                    "checkbox-el__error":
                      _vm.agreements_error[term.accpetnace_group.name],
                    "d-none":
                      term.accpetnace_group.name === "newsletter" &&
                      _vm.is_logged,
                  },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.value[term.accpetnace_group.name],
                        expression: "value[term.accpetnace_group.name]",
                      },
                    ],
                    staticClass: "checkbox-el__input",
                    attrs: {
                      name: term.accpetnace_group.name,
                      id: term.accpetnace_group.name,
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.value[term.accpetnace_group.name]
                      )
                        ? _vm._i(_vm.value[term.accpetnace_group.name], null) >
                          -1
                        : _vm.value[term.accpetnace_group.name],
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.value[term.accpetnace_group.name],
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.value,
                                  term.accpetnace_group.name,
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.value,
                                  term.accpetnace_group.name,
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.value, term.accpetnace_group.name, $$c)
                          }
                        },
                        function ($event) {
                          return _vm.unCheckOne(term.accpetnace_group.name)
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass:
                        "checkbox-el__label checkbox-el__label--padding-small d-flex justify-content-between align-items-center}",
                      attrs: { for: term.accpetnace_group.name },
                    },
                    [
                      _c("span", { staticClass: "d-flex align-items-start" }, [
                        _c("span", { staticClass: "checkmark mr-4 mt-1" }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "checkbox-el__label__text checkbox-el__label__text--small font__family--gotham font__weight--light font__color--gray",
                          },
                          [
                            _vm._v(
                              "\n                                          " +
                                _vm._s(term.accpetnace_group.acceptance) +
                                "\n                                      "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ])
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }